










































































































































import { Component, PropSync, Vue, Watch } from "vue-property-decorator"
import { mapState } from "vuex"
import QDatePicker from "@/components/Booking/QDatePicker.vue"
import _ from "lodash"

@Component({
  components: {
    QDatePicker,
  },
  computed: {
    ...mapState("Booking", {
      booking: "booking",
    }),
  },
})
export default class BookingReadBookingCandidateFormFields extends Vue {
  @PropSync("value") bookingCandidate!: BookingCandidate

  booking!: Model

  isLoading = false

  localBookingCandidate: BookingCandidate = {}

  channel: string[] = []

  isEmailCheckboxDisabled = false

  isSMSCheckboxDisabled = false

  get bookingCandidates() {
    return this.booking.booking_candidates || []
  }

  @Watch("isEmailCheckboxDisabled")
  watchIsEmailCheckboxDisabled(isDisabled) {
    if (isDisabled) {
      this.channel.splice(this.channel.indexOf("sms"), 1)
    }
  }

  @Watch("isSMSCheckboxDisabled")
  watchIsSMSCheckboxDisabled(isDisabled) {
    if (isDisabled) {
      this.channel.splice(this.channel.indexOf("sms"), 1)
    }
  }

  beforeMount() {
    this.localBookingCandidate = _.cloneDeep(this.bookingCandidate)
  }

  disableEmailCheckbox(errors) {
    this.isEmailCheckboxDisabled =
      _.isEmpty(this.localBookingCandidate.email) || errors.email?.length > 0

    return this.isEmailCheckboxDisabled
  }

  disableSMSCheckbox(errors) {
    this.isSMSCheckboxDisabled =
      _.isEmpty(this.localBookingCandidate.mobile) || errors.mobile?.length > 0

    return this.isSMSCheckboxDisabled
  }

  async updateBookingCandidate() {
    this.isLoading = true
    await this.$store
      .dispatch("BookingCandidate/update", this.localBookingCandidate)
      .then(() => {
        for (const key in this.bookingCandidate) {
          this.bookingCandidate[key] =
            this.localBookingCandidate[key] || this.bookingCandidate[key]
        }
      })
    this.isLoading = false
  }

  existingEmails(v) {
    let existingEmails: string[] = []
    existingEmails = this.bookingCandidates.map(function (entry) {
      return entry.email
    })
    existingEmails = existingEmails.filter(Boolean)
    const index = existingEmails.indexOf(v)
    if (index >= 0) {
      existingEmails.splice(index, 1)
    }
    return existingEmails
  }

  existingMobiles(v) {
    let existingMobiles: string[] = []
    existingMobiles = this.bookingCandidates.map(function (entry) {
      return entry.mobile
    })
    existingMobiles = existingMobiles.filter(Boolean)
    const index = existingMobiles.indexOf(v)
    if (index >= 0) {
      existingMobiles.splice(index, 1)
    }
    return existingMobiles
  }

  failedRulesToErrorMessage(failedRules: { [key: string]: string }) {
    const errorMessage: string[] = []
    for (const [key, value] of Object.entries(failedRules)) {
      errorMessage.push(value)
    }
    return errorMessage
  }

  async sendNotification() {
    this.isLoading = true
    await this.$store
      .dispatch("BookingCandidate/sendNotification", {
        object_id: this.bookingCandidate.object_id,
        body: {
          channel: this.channel,
          ...this.localBookingCandidate,
        },
      })
      .then(() => {
        for (const key in this.bookingCandidate) {
          this.bookingCandidate[key] =
            this.localBookingCandidate[key] || this.bookingCandidate[key]
        }
      })
    this.isLoading = false
    this.channel = []
  }
}
